import { CashbackOfferType } from "../CashbackOfferType";
export function isBankLoyaltyParams(primitives) {
    return primitives.type === CashbackOfferType.BANK_LOYALTY;
}
